import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { FullPageLoader, Button } from "@/components/ds";
import { MfaManager } from "@/components/security/MfaManager";

export default function MfaSetup() {
  const { user, mfaEnrollmentRequired } = useAuth();
  const navigate = useNavigate();

  if (user === null) return <FullPageLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  // Enrollment already satisfied — no need to be here.
  if (!mfaEnrollmentRequired) return <Navigate to="/app/dashboard" replace />;

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-12" data-testid="page-mfa-setup">
      <div className="mx-auto max-w-lg">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
            <ShieldCheck className="h-6 w-6 text-blue-600" />
          </div>
          <h1 className="text-2xl font-semibold text-slate-900">Secure your account</h1>
          <p className="mt-1 text-sm text-slate-500">
            Two-factor authentication is required before you can continue.
          </p>
        </div>
        <MfaManager onEnabled={() => navigate("/app/dashboard")} />
      </div>
    </div>
  );
}
